import { Spinner, Text, VStack } from "@chakra-ui/react";

const FixedLoader = () => (
    <VStack
        style={{
            display: "flex",
            justifyContent: "center",
            position: "absolute",
            bottom: "50%",
            background: "transparent",
            width: "100%",
            padding: "4px 0",
        }}
    >
        <Spinner />
        <Text>Loading...</Text>
    </VStack>
);

export default FixedLoader;
